import {usePaging} from "@/modules/reader/book/paging";
import AbstractAnnotations from "@/modules/reader/annotations/AbstractAnnotations";

class StepByStepAnnotation extends AbstractAnnotations{


    constructor(builder) {

        super();
        const { pageState, setCurrentPage} = usePaging();
        this.annotations.domPos = builder.domPos;
        this.annotations.protocol = builder.protocol;
        this.annotations.isStepByStepBtn = true;

        for (let [key,value] of Object.entries(builder.meta)) {

            if (key === "id") {
                super.setAnnotations({"id":value});
            }
            else if (key === "icon") {
                super.setAnnotations({"iconSrc":value});
            }
            else if (key === "targetRectId") {
                super.setAnnotations({"targetRectId":value});
            }
            else if (key === "t") {
                super.setAnnotations({[key]: parseInt(value)});
            }
            else  if (key === "images") {
                super.setAnnotations({"imgSrcList":value.split(",")});
            }
        }

    }

}

export default StepByStepAnnotation